function generateUUID(): string {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    const v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

export class TraceContext {
  private readonly correlationId: string;
  private readonly operation: string | undefined;

  constructor(correlationId?: string, operation?: string) {
    this.correlationId = correlationId ?? generateUUID();
    this.operation = operation;
  }

  startOperation(name: string): TraceContext {
    return new TraceContext(generateUUID(), name);
  }

  getCurrentId(): string {
    return this.correlationId;
  }

  getCurrentOperation(): string | undefined {
    return this.operation;
  }
}
